import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setChangeUserEmailFormAction } from "../../redux/rootReducer";
import { CHANGE_USER_EMAIL_FORM_INITIAL } from "../../redux/initialStateConstant";
import { ChangeUserEmailThunk } from "../../redux/thunks/ChangeUserEmailThunk";

const ChangeUserEmailForm = () => {
    const dispatch = useDispatch();
    const change_user_email_form = useSelector(state => state.change_user_email_form);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close"
                             onClick={ () => {
                                 dispatch(setChangeUserEmailFormAction(CHANGE_USER_EMAIL_FORM_INITIAL));
                             } }
                        />
                        <div className="form__title">Смена почты</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Адрес почты</div>
                        <input type="text" className="input"
                            value={ change_user_email_form.email }
                            onInput={ event => {
                                dispatch(setChangeUserEmailFormAction({
                                    ...change_user_email_form,
                                    email: event.target.value
                                }));
                            } }
                        />
                    </div>
                    <div className="form__field">
                        <div className="button"
                             onClick={ () => {
                                 dispatch(ChangeUserEmailThunk({
                                     email: change_user_email_form.email
                                 }));
                             } }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangeUserEmailForm;